import { Box, Button, Typography, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import { setRedirectTo, userLogin } from "../../redux/action";
import { getToken } from "../../redux/selector";
import { isNotEmpty } from "../../Utils";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
import "../LoginPage/LoginPage.scss";

const useStyles = makeStyles({
    root: {
        width: "85%",
        height: "100%",
        margin: "6px 100px 0px 50px",
        flex: 1,
    },
    rootMobile: {
        margin: "6px 0px 0px 0px",
        flex: 1,
    },
    eye: {
        transform: "translate(10px)",
    },
});

export default function LoginSSLODialog({ onLogin }) {
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const matches = useMediaQuery("(min-width:600px)");
    const dispatch = useDispatch();
    let location = useLocation();
    let navigate = useNavigate();
    const [visible, setVisible] = useState(false);

    const { register, handleSubmit, watch, formState, setError } = useForm({
        defaultValues: {
            username: "",
            password: "",
        },
        mode: "onBlur",
    });

    const token = useSelector(getToken());
    const [cookies, setCookie] = useCookies(["token"]);
    useEffect(() => {
        // when login success
        if (isNotEmpty(token)) {
            onLogin();
            setCookie("token", token, {
                path: `${Config.CONTENT_PATH}`,
                maxAge: 3600,
                secure: true,
            });
        }
    }, [token]);

    const onFetchError = () => {
        setError("password", {
            type: "invalid",
            message: t(`errorMsg.login.invalid`),
        });
    };

    const onSubmit = (formData) => {
        window.grecaptcha.ready(function () {
            window.grecaptcha
                .execute("6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM", {
                    action: "submit",
                })
                .then(function (token) {
                    formData["response"] = token;
                    dispatch(userLogin(formData, onFetchError)).then(
                        (result) => {
                            console.log("formData:" + JSON.stringify(formData));
                            let url = result?.redirectUrl;
                            if (url != null) {
                                let redirectUrl = location.pathname;
                                dispatch(setRedirectTo(redirectUrl));
                                navigate(url); //Change password (point to)
                            } else {
                                const msgList = {
                                    ACCOUNT_LOCKED: "accountLocked",
                                };
                                if (
                                    isNotEmpty(result?.msg) &&
                                    isNotEmpty(msgList?.[result?.msg])
                                ) {
                                    setError("password", {
                                        type: "invalid",
                                        message: msgList[result.msg],
                                    });
                                }
                            }
                        }
                    );
                });
        });
    };

    const onClickVisible = () => {
        if (visible) {
            setVisible(false);
        } else {
            setVisible(true);
        }
    };

    const errors = formState.errors;

    const pointToForgotPw = () => {
        navigate("/ForgotPassword");
    };
    return (
        <Box width={400}>
            <Box
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    height: "100%",
                }}
            >
                <Typography variant="h5">
                    SSLO {t("common.sideNavList.login")}
                    <br />
                    <br />
                </Typography>
                <CustomTextField
                    label={t("common.portal.username")}
                    required={false}
                    inputProps={register("username", {
                        validate: {
                            valid: (value) =>
                                value.includes("@") || t("errorMsg.email.rule"),
                        },
                        required: t("errorMsg.email.rule"),
                    })}
                    type="email"
                />
                <ErrorMsg message={errors?.username?.message} />

                <CustomTextField
                    label={t("common.portal.password")}
                    required={false}
                    inputProps={register("password")}
                    type={visible ? null : "password"}
                    unit={
                        visible === true ? (
                            <Button
                                onClick={onClickVisible}
                                disableRipple={true}
                                className={classes.eye}
                            >
                                <VisibilityOffIcon style={{ color: "gray" }} />
                            </Button>
                        ) : (
                            <Button
                                onClick={onClickVisible}
                                disableRipple={true}
                                className={classes.eye}
                            >
                                <VisibilityIcon style={{ color: "gray" }} />
                            </Button>
                        )
                    }
                />
                {errors?.password?.message && (
                    <ErrorMsg
                        message={t(
                            "common.login.error." + errors?.password?.message
                        )}
                    />
                )}

                <br />
                <br />
                <Box>
                    <Button
                        className="buttons"
                        variant="contained"
                        color="primary"
                        type="submit"
                        style={{ marginRight: "10px" }}
                        onClick={handleSubmit(onSubmit)}
                        data-action="submit"
                        data-sitekey="6LeWvVwdAAAAAI9JwB5OcndiYHiCA_LCISNCmTiM"
                        data-callback="onSubmit"
                    >
                        {t("common.sideNavList.login")}
                    </Button>
                    <Button
                        className="buttons"
                        variant="contained"
                        color="primary"
                        style={{ marginLeft: "10px" }}
                        onClick={pointToForgotPw}
                    >
                        {t("common.portal.forgotPassword")}
                    </Button>
                </Box>
            </Box>
            <div className={"dialog-page"}>
                {t("reCaptcha.lng")}
                <a
                    href={t("reCaptcha.policyLink")}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t("reCaptcha.priPolicy")}
                </a>{" "}
                {t("reCaptcha.and")}
                <a
                    href={t("reCaptcha.termsLink")}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t("reCaptcha.terService")}
                </a>{" "}
                {t("reCaptcha.apply")}
                {/*</p>*/}
            </div>
        </Box>
    );
}
